<div class="spinner-overlay">
  <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
</div>
